import { MiddlewareAPI } from '@reduxjs/toolkit';
import InlineAggregateLayer from '@/components/layers/InlineAggregateLayer';
import { getQueryBuilderSteps } from '@/store-selectors';
import { userActionFiredAction } from '@/actions/action-creators';
import { IntercomAPI } from '@/integrations/Intercom';
import { UserActionPayload } from './types';

export const getNextSummarizeStep = ({ type, payload }: UserActionPayload) =>
  type === 'LAYER_USER_INTERACTION' &&
  payload?.props?.updatedLayer?.type() === 'AGGREGATE'
    ? payload.props.updatedLayer
    : undefined;

export const getCurrentState = (
  store: MiddlewareAPI,
  nextSummarizeStep: InlineAggregateLayer,
  verificationFn: F2<InlineAggregateLayer, InlineAggregateLayer, boolean>,
) => {
  const currentState = store.getState();
  const currentSteps = getQueryBuilderSteps(currentState);

  const currentSummarizeStep = currentSteps.find(
    (s) => s.id() === nextSummarizeStep.id(),
  ) as InlineAggregateLayer;

  return verificationFn(currentSummarizeStep, nextSummarizeStep)
    ? currentState
    : undefined;
};

export const createActionsData = (actionName: string, meta = {}) => ({
  _actions: [
    {
      _actionAt: new Date().toISOString(),
      _action: actionName,
      _meta: meta,
    },
  ],
});

export const processAction =
  (actionName: string, store: MiddlewareAPI) => () => {
    store.dispatch(userActionFiredAction(actionName));
    IntercomAPI.trackEvent(actionName);
    return Promise.resolve();
  };
